
import axios from 'axios';

import {
  defineComponent,
  ref,
  onMounted,
} from 'vue';

import type { Option } from '@/types';

export default defineComponent({
  setup() {
    const options = ref<Option[]>([]);

    const loading = ref(true);

    onMounted(async () => {
      try {
        const response = await axios.get('/api/v3/timezones/options');

        options.value = response.data;
      } finally {
        loading.value = false;
      }
    });

    return {
      options,
      loading,
    };
  },
});
